const initState = {
    type: '',
    settingList: null,
    currentSetting: null,
    response: null,
    error: null,
    tagSettings: { theme: [], product: [] },
    tagSettingsCurrent: { theme: [], product: [] },
}

const settingReducer = (state = initState, action) => {

    switch (action.type) {
        case 'SETTING_INIT': return { ...state, type: action.type, error: null, currentSetting: action.payload }

        case 'SETTING_LIST_PENDING': return { ...state, type: action.type, error: null }
        case 'SETTING_LIST_SUCCESS': return { ...state, type: action.type, error: null, settingList: action.payload }
        case 'SETTING_LIST_ERROR': return { ...state, type: action.type, error: action.payload, settingList: [] }

        case 'SETTING_SELECT_PENDING': return { ...state, type: action.type, error: null }
        case 'SETTING_SELECT_SUCCESS': return { ...state, type: action.type, error: null, currentSetting: action.payload }
        case 'SETTING_SELECT_ERROR': return { ...state, type: action.type, error: action.payload }

        case 'SETTING_UPDATE_PENDING': return { ...state, type: action.type, error: null }
        case 'SETTING_UPDATE_SUCCESS': return { ...state, type: action.type, error: null, response: action.payload }
        case 'SETTING_UPDATE_ERROR': return { ...state, type: action.type, error: action.payload }

        case "SET_TAG_SETTINGS": { return { ...state, tagSettings: action.payload } }
        case "SET_TAG_SETTINGS_CURRENT": { return { ...state, tagSettingsCurrent: action.payload } }

        case "SET_SETTING_LIST": {
            return { ...state, settingList: action.payload }
        }

        default: return state;
    }
};

export default settingReducer;